import React from 'react';
import { SectionLabel } from './SectionLabel';
import { stages } from '../data/offer';
export function Roadmap() {
  return <section className="w-full bg-white" aria-labelledby="roadmap-heading" data-id="element-221" data-mp="19nycl21mfbf4">
      <div className="mx-auto max-w-6xl px-4 py-14 sm:px-5 sm:py-24" data-id="element-222" data-mp="14v5ayn1g8j79">
        <SectionLabel data-id="element-223" data-mp="zwtys5nolwlv">The main program: 30-day system</SectionLabel>

        <h2 id="roadmap-heading" className="mt-5 font-display text-[1.75rem] font-semibold leading-tight text-ink sm:mt-6 sm:text-[2.75rem]" data-id="element-224" data-mp="zwk9kkagnth8">
          Six stages, day by day
        </h2>

        <p className="mt-4 max-w-2xl text-[15px] leading-relaxed text-muted sm:mt-5 sm:text-lg" data-id="element-225" data-mp="qyibaci43exn">
          Your day-by-day blueprint to master basic commands and build an
          unbreakable bond. No fluff, no academic theory — just a
          15-minute-a-day protocol. (Value: $97)
        </p>

        <ul className="mt-9 grid gap-px bg-line sm:mt-12 lg:grid-cols-2" data-id="element-226" data-mp="2g8pu0wgt0j7s">
          {stages.map(stage => <li key={stage.number} className="flex flex-col bg-white px-5 py-7 sm:px-8 sm:py-10" data-id="element-227" data-mp="2k4ceu3jtdhvz">
              <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-terracotta sm:text-[11px] sm:tracking-[0.2em]" data-id="element-228" data-mp="2o6zdanazq125">
                Stage {stage.number}
              </p>
              <h3 className="mt-3 font-display text-xl font-semibold leading-tight text-ink sm:mt-4 sm:text-2xl" data-id="element-229" data-mp="2f4gau4b49qgf">
                {stage.title}
              </h3>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-muted sm:mt-4 sm:text-[15px]" data-id="element-230" data-mp="32x6lma7aa3p4">
                {stage.description}
              </p>
              <ul className="mt-5 flex flex-wrap gap-1.5 sm:mt-6 sm:gap-2" data-id="element-231" data-mp="2t47vup01w73x">
                {stage.tags.map(tag => <li key={tag} className="rounded-full border border-line px-3 py-1 text-[11px] font-medium uppercase tracking-[0.08em] text-ink/60" data-id="element-232" data-mp="2y29fbb1e28fx">
                    {tag}
                  </li>)}
              </ul>
            </li>)}
        </ul>
      </div>
    </section>;
}